import * as React from 'react'
import './LinkFilters.scss'
import moment from 'moment';
import {ActionType,CHAINTYPES,reducerStoreType, RecordsSearchType, ROLES} from "../../reducers/types";
import FormControl from "@material-ui/core/FormControl";
import Select from '@material-ui/core/Select';
import {MyInput, Label, MyMenuItem} from "../../components/CustomUIComp/CustomFormElem";
import Grid from "@material-ui/core/Grid";
import {injectIntl, IntlShape} from "react-intl";
import Loadable from "react-loadable";
import 'react-dates/lib/css/_datepicker.css';
import {Dispatch} from "redux";
import {connect} from "react-redux";

interface IProps {
	dispatch: Dispatch<ActionType<any>>,
    filters: RecordsSearchType,
    chainType: CHAINTYPES,
    role: ROLES,
    intl: IntlShape
}

interface IState {
    focusedInput: string | null
}

const LoadableComponent = Loadable({
    loader: () => import('./LinkDatePicker'),
    loading(){ return (<div>loading...</div>)},
});

class LinkFilters extends React.Component<IProps,IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            focusedInput: null
        }
    }
	
    handleDateChange = (value: any) => {
		let start = ''
		let end = ''
        if (value.startDate) {
            start = moment(value.startDate).format("YYYY-MM-DD")
        }
        if (value.endDate) {
            end = moment(value.endDate).format("YYYY-MM-DD")
        }
		this.props.dispatch({type: 'SET_EXCHANGE_RECORDS_DATE', payload:{startDate:start,endDate:end}})
    }
    handleFocuseChange = (value: any) => {
        this.setState({focusedInput: value})
    }
	
	handleStatusChange = (status:any) => {
		this.props.dispatch({type: 'SET_EXCHANGE_RECORDS_STATUS', payload:status})
	}
	
	handleConfirm = () => {
		this.props.dispatch({type: 'SEARCH_EXCHANGE_RECORDS',payload:{}})
	}
	
	handleClear =() => {
		this.props.dispatch({type: 'CLEAR_EXCHANGE_RECORDS_FILTERS', payload:{}})
		this.props.dispatch({type: 'RELOAD_PAGE', payload: {}})
	}
	
    getSettleStatus = () => {
        let {intl} = this.props
        return [
            {value: -1, label: intl.formatMessage({id: 'all'})},
            {value: 1, label: intl.formatMessage({id: 'exchangeSucc'})},
            {value: 0, label: intl.formatMessage({id: 'untreated'})}
        ]
    }

    public render() {
        const settlementOptions = this.getSettleStatus()
        let {filters, intl} = this.props
        return (
            <div className="OrderFilters">
                <Grid container spacing={2}>
                    <Grid item>
                        <LoadableComponent filters={filters}
                                         handleDateChange={this.handleDateChange}
                                         focusedInput={this.state.focusedInput}
                                         handleFocuseChange={this.handleFocuseChange}/>
                    </Grid>
                    <Grid item>
                        <div className="filterItem">
                            <FormControl className="formControl">
                                <Label shrink htmlFor="settle-status-select">
                                    {intl.formatMessage({id: 'transactionStatus'})}
                                </Label>
                                <Select
                                    value={filters.status}
									onChange={
										(event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleStatusChange({
										    Status: event.target.value
										})
									}
                                    input={<MyInput width={130}  labelmargin={18}  border="none" id="settle-status-select" name="status"/>}
                                >
                                    {
                                        settlementOptions.map((item, i) => {
                                            return <MyMenuItem key={`settle-statues-${item.value}`}
                                                               value={item.value}>{item.label}</MyMenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    </Grid>
                </Grid>
                <div className="buttons">
                    <button className="primaryButton" onClick={this.handleConfirm}>{intl.formatMessage({id: 'query'})}</button>
                    <button className="whiteButton" onClick={this.handleClear}>{intl.formatMessage({id: 'clear'})}</button>
                </div>
            </div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
        filters: state.exchangeRecords.RecordsFilters,
		chainType: state.merchant.merchantInfo.chainType,
		role: state.app.userInfo ? state.app.userInfo.role : ROLES.NONE
    }
})(LinkFilters))